import { registerEnumSet } from '@if/mui'
import { CircleCheck, Clock } from 'lucide-react'

export const ECustomBuydownPlanStatus = {
  Active: 'active',
  Scheduled: 'scheduled',
} as const

export type CustomBuydownPlanStatus = (typeof ECustomBuydownPlanStatus)[keyof typeof ECustomBuydownPlanStatus]

registerEnumSet(ECustomBuydownPlanStatus, {
  active: { color: 'success', icon: CircleCheck, labelKey: 'customBuydown.timeline.status.active' },
  scheduled: { color: 'info', icon: Clock, labelKey: 'customBuydown.timeline.status.scheduled' },
})
